<template>
    <div>
        <ion-header>
            <ion-toolbar>
                <ion-title>Bitte beachten</ion-title>
                <ion-buttons slot="end">
                    <ion-button @click="$ionic.modalController.dismiss()">
                        <ion-icon slot="icon-only" name="close"></ion-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-padding">
            <div v-html="content"></div>
        </ion-content>
    </div>
</template>

<script>
export default {
    props: {
        content: {
            type: String,
            required: true,
        },
    },
};
</script>
